import { render, staticRenderFns } from "./appeal.vue?vue&type=template&id=3021bb76&scoped=true&"
import script from "./appeal.vue?vue&type=script&lang=js&"
export * from "./appeal.vue?vue&type=script&lang=js&"
import style0 from "./appeal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./appeal.vue?vue&type=style&index=1&id=3021bb76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3021bb76",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VSelect,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3021bb76')) {
      api.createRecord('3021bb76', component.options)
    } else {
      api.reload('3021bb76', component.options)
    }
    module.hot.accept("./appeal.vue?vue&type=template&id=3021bb76&scoped=true&", function () {
      api.rerender('3021bb76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/appeal.vue"
export default component.exports